import { styled } from '@styledComponents';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';
import { CloudImage } from '@components/CloudImage';

export const StyledSection = styled(Box)`
  position: relative;
  width: 100%;
`;

export const ColumnFlex = styled(Flex)`
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(10)};
  }
`;

export const FeatureText = styled(TextPairing)`
  margin-top: ${themeSpace(4)};
  .text-pairing-body {
    max-width: 210px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-body {
      max-width: 280px;
    }
  }
`;

export const StyledColumn = styled(Columns)`
  ${themeMediaQuery('sm')} {
    max-width: 65rem;
  }
  ${themeMediaQuery('lg')} {
    max-width: 90rem;
  }
`;

export const FeaturesTextPairing = styled(TextPairing)`
  margin-top: ${themeSpace(8)};
  margin-bottom: ${themeSpace(8)};
  .text-pairing-body {
    max-width: 380px;
  }
`;

export const StyledTopWave = styled(CloudImage)`
  width: 100%;
  position: absolute;
  z-index: 2;
  ${themeMediaQuery('below_sm')} {
    top: -20px;
  }
  ${themeMediaQuery('sm')} {
    top: -50px;
  }
  ${themeMediaQuery('md')} {
    top: -60px;
  }
  ${themeMediaQuery('lg')} {
    top: -90px;
  }
`;

export const StyledBottomGoldThread = styled(CloudImage)`
  width: 100%;
  position: absolute;
  z-index: 2;
  ${themeMediaQuery('below_sm')} {
    bottom: -15px;
  }
  ${themeMediaQuery('sm')} {
    bottom: -50px;
  }
  ${themeMediaQuery('md')} {
    bottom: -60px;
  }
  ${themeMediaQuery('lg')} {
    bottom: -70px;
  }
`;
